
<div class="container">
    <div class="main-header">
        <slot name="main-header" />
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between; flex: 1 1 66%; column-gap: 10px;">
        <div class="main-search">
            <slot name="main-search" />
        </div>
        <div class="main-buttons">
            <slot name="main-buttons"/>
        </div>
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
    }
    .main-header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex: 1 1 33%;
        font-size: var(--font-size-page-header);
    }
    .main-search {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex: 1 1 50%;
    }
    .main-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex: 1 1 50%;
    }

</style>
